import React from 'react';
import { DataSet } from '@facet-wealth/design';

export const useDataSet = (dataSetResource) => {
  const dataSeriesResources = React.useMemo(() => dataSetResource.attr('dataSeries').resources().list(), [dataSetResource]);

  const dataSeries = React.useMemo(() => {
    return dataSeriesResources.map((dataSeriesResource) => {
      return {
        referenceName: dataSeriesResource.id(),
        groupName: dataSetResource.id(),
        name: dataSeriesResource.attr('label'),
        representation: dataSeriesResource.attr('representation'),
        color: dataSeriesResource.attr('color') && dataSeriesResource.attr('color'),
        dataPointFormats: dataSeriesResource.attr('formats'),
        points: dataSeriesResource.attr('dataPoints').resources().list().map((dataPointResource) => {
          return {
            x: new Date(dataPointResource.attr('x')),
            y: Number(dataPointResource.attr('y')),
            meta: {},
          };
        }),
      };
    });
  }, [dataSeriesResources]);

  return new DataSet({
    series: dataSeries,
  });
};
